import './Error.sass';

import React, { FC, useEffect } from 'react';
import { Placeholder, Button, LottieIcon, AnimatedEmoji } from '$uikit';
import { useDispatch } from 'react-redux';
import { mainActions } from '$store/main';

import('$assets/lottie/sad.json'); // For offline cache.

export const Error: FC = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(mainActions.checkConnection());
  }, []);

  return (
    <div className="Error">
      <Placeholder
        centered
        iconSize={112}
        icon={<AnimatedEmoji emoji="🤕" />}
        title="Ton.Place is under maintenance"
        actions={
          <Button onClick={() => window.location.reload()}>Refresh the page</Button>
        }
      >
        We’ll be back soon!
      </Placeholder>
    </div>
  );
};
